import { render, staticRenderFns } from "./configuration_activity_edit_change_assistant_type_modal.vue?vue&type=template&id=0fc9e952"
import script from "./configuration_activity_edit_change_assistant_type_modal.vue?vue&type=script&lang=js"
export * from "./configuration_activity_edit_change_assistant_type_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports